import { Camera, CameraResultType } from "@capacitor/camera";
import { Capacitor } from "@capacitor/core";
import { CameraIcon, CrossCircledIcon } from "@radix-ui/react-icons";
import Image from "./Image";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import resizeImageFromDataUrl from "src/lib/resizeImage";

export const PhotoFormField = ({
  field,
  maxSize,
}: {
  field: any;
  maxSize?: number;
}) => {
  return (
    <>
      {Capacitor.isNativePlatform() && (
        <>
          {field.value && (
            <Button
              size="icon"
              variant="destructive"
              type="button"
              onClick={() => {
                field.onChange(null);
              }}
              className="ml-2"
            >
              <CameraIcon />
              <CrossCircledIcon />
            </Button>
          )}
          <Button
            size="icon"
            onClick={() => {
              Camera.getPhoto({
                quality: 100,
                allowEditing: false,
                resultType: CameraResultType.DataUrl,
              })
                .then(async (photo) => {
                  const dataUrl = await resizeImageFromDataUrl({
                    dataUrl: photo.dataUrl as string,
                    maxSize,
                  });
                  field.onChange(dataUrl);
                })
                .catch(() => {});
            }}
            className="ml-2"
            type="button"
          >
            <CameraIcon />
          </Button>
        </>
      )}

      {!Capacitor.isNativePlatform() && (
        <Input
          type="file"
          autoComplete="photo"
          id="photo"
          onChange={(event) => {
            event.preventDefault();
            const { files } = event.target;
            if (!files?.[0]) {
              field.onChange(null);
              return;
            }
            const reader = new FileReader();
            reader.onloadend = async () => {
              const dataUrl = await resizeImageFromDataUrl({
                dataUrl: reader.result as string,
                maxSize,
              });
              if (!dataUrl) return;
              field.onChange(dataUrl);
            };
            reader.readAsDataURL(files[0]);
          }}
        />
      )}

      {field.value && (
        <div
          className="mt-2"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Image
            src={field.value}
            alt="Fotografie uživatele"
            style={{ maxHeight: "5rem", maxWidth: "10rem", margin: 0 }}
          />
        </div>
      )}
    </>
  );
};
